module.exports = __webpack_public_path__ + "static/media/bg_without_flag01.9cc7fd7b.jpg";